import { Observable, throwError, switchMap } from "rxjs";
import { fromFetch } from "rxjs/fetch";
import { MaterialProperties, SurfaceTreatment } from "../types/CommonTypes";

/**
 * Fetches the full cached list of all surface treatments (global, not material-specific).
 * Used to populate the grid with all known STs, which are then filtered by "approved" status.
 */
export function fetchAllSurfaceTreatments(): Observable<SurfaceTreatment[]> {
    return fromFetch(`/api/material/surface-treatments`).pipe(
        switchMap(response => {
            if (response.ok) {
                return response.json() as Promise<SurfaceTreatment[]>;
            } else {
                return throwError(
                    () => new Error(`Failed to fetch all surface treatments: ${response.statusText}`)
                );
            }
        })
    );
}

/**
 * Fetches surface treatments, colours and dimensions for a specific base
 * material in a single request.
 */
export function fetchMaterialProperties(bmId: string): Observable<MaterialProperties> {
    return fromFetch(`/api/material/get-material-info?bmId=${bmId}`).pipe(
        switchMap(response => {
            if (response.ok) {
                return response.json() as Promise<MaterialProperties>;
            } else {
                return throwError(
                    () => new Error(
                        `Failed to fetch material properties for ${bmId}: ${response.statusText}`
                    )
                );
            }
        })
    );
}
